import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { AppFile } from "../../../models";
import AppFileService from "../../../services/AppFileService";
import Breadcrumbs from "../../../components/breadcrumbs";
import AppFileUpdateForm from "./ui/AppFileUpdateForm";
import AppFileUpdateFormSkeleton from "./skeletons/AppFileUpdateFormSkeleton";
import NotFound from "../../../components/not-found";

export default function AppFileEditPage() {
  const { id } = useParams<{ id: string }>();
  const [appFile, setAppFile] = useState<AppFile | null>(null);
  const [loading, setLoading] = useState(true);
  const api = new AppFileService();

  useEffect(() => {
    if (id) {
      api
        .getAppFile(id)
        .then((data) => {
          setAppFile(data);
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
          setLoading(false);
        });
    }
  }, [id]);

  if (loading) return <AppFileUpdateFormSkeleton/>;
  if (!appFile) return <NotFound message="App File not found."></NotFound>;

  return (
    <main className="max-w-3xl">
      <Breadcrumbs
        breadcrumbs={[
          { label: "App Files", href: "/admin/app-files" },
          { label: "Edit File", href: `/admin/app-files/edit/${id}`, active: true },
        ]}
      />   
      <AppFileUpdateForm appFile={appFile} />
    </main>
  );
}